// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/facilityGroup.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/facilityGroup.proto.
 */
export const file_core_v1_facilityGroup: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_types]);

/**
 * FacilityGroup represents a logical grouping of facilities
 *
 * @generated from message core.v1.FacilityGroup
 */
export type FacilityGroup = Message<"core.v1.FacilityGroup"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: types.Base base = 3;
   */
  base?: Base;

  /**
   * @generated from field: map<string, bytes> custom_attributes = 4;
   */
  customAttributes: { [key: string]: Uint8Array };
};

/**
 * Describes the message core.v1.FacilityGroup.
 * Use `create(FacilityGroupSchema)` to create a new message.
 */
export const FacilityGroupSchema: GenMessage<FacilityGroup> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 0);

/**
 * @generated from message core.v1.CreateFacilityGroupRequest
 */
export type CreateFacilityGroupRequest = Message<"core.v1.CreateFacilityGroupRequest"> & {
  /**
   * @generated from field: core.v1.CreateFacilityGroupInput input = 1;
   */
  input?: CreateFacilityGroupInput;
};

/**
 * Describes the message core.v1.CreateFacilityGroupRequest.
 * Use `create(CreateFacilityGroupRequestSchema)` to create a new message.
 */
export const CreateFacilityGroupRequestSchema: GenMessage<CreateFacilityGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 1);

/**
 * @generated from message core.v1.CreateFacilityGroupInput
 */
export type CreateFacilityGroupInput = Message<"core.v1.CreateFacilityGroupInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated types.ID facility_ids = 3;
   */
  facilityIds: ID[];

  /**
   * @generated from field: map<string, bytes> custom_attributes = 4;
   */
  customAttributes: { [key: string]: Uint8Array };
};

/**
 * Describes the message core.v1.CreateFacilityGroupInput.
 * Use `create(CreateFacilityGroupInputSchema)` to create a new message.
 */
export const CreateFacilityGroupInputSchema: GenMessage<CreateFacilityGroupInput> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 2);

/**
 * @generated from message core.v1.UpdateFacilityGroupRequest
 */
export type UpdateFacilityGroupRequest = Message<"core.v1.UpdateFacilityGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated types.ID facility_ids = 3;
   */
  facilityIds: ID[];

  /**
   * @generated from field: map<string, bytes> custom_attributes = 4;
   */
  customAttributes: { [key: string]: Uint8Array };
};

/**
 * Describes the message core.v1.UpdateFacilityGroupRequest.
 * Use `create(UpdateFacilityGroupRequestSchema)` to create a new message.
 */
export const UpdateFacilityGroupRequestSchema: GenMessage<UpdateFacilityGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 3);

/**
 * @generated from message core.v1.GetFacilityGroupRequest
 */
export type GetFacilityGroupRequest = Message<"core.v1.GetFacilityGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.GetFacilityGroupRequest.
 * Use `create(GetFacilityGroupRequestSchema)` to create a new message.
 */
export const GetFacilityGroupRequestSchema: GenMessage<GetFacilityGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 4);

/**
 * @generated from message core.v1.DeleteFacilityGroupRequest
 */
export type DeleteFacilityGroupRequest = Message<"core.v1.DeleteFacilityGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.DeleteFacilityGroupRequest.
 * Use `create(DeleteFacilityGroupRequestSchema)` to create a new message.
 */
export const DeleteFacilityGroupRequestSchema: GenMessage<DeleteFacilityGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 5);

/**
 * @generated from message core.v1.ListFacilityGroupsRequest
 */
export type ListFacilityGroupsRequest = Message<"core.v1.ListFacilityGroupsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: string search_term = 4;
   */
  searchTerm: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 5;
   */
  lastUpdatedAt?: Timestamp;

  /**
   * @generated from field: repeated core.v1.FacilityGroupSortOption sorting = 6;
   */
  sorting: FacilityGroupSortOption[];

  /**
   * @generated from field: int32 offset = 7;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 8;
   */
  limit: number;
};

/**
 * Describes the message core.v1.ListFacilityGroupsRequest.
 * Use `create(ListFacilityGroupsRequestSchema)` to create a new message.
 */
export const ListFacilityGroupsRequestSchema: GenMessage<ListFacilityGroupsRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 6);

/**
 * @generated from message core.v1.ListFacilityGroupsResponse
 */
export type ListFacilityGroupsResponse = Message<"core.v1.ListFacilityGroupsResponse"> & {
  /**
   * @generated from field: repeated core.v1.FacilityGroup facility_groups = 1;
   */
  facilityGroups: FacilityGroup[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message core.v1.ListFacilityGroupsResponse.
 * Use `create(ListFacilityGroupsResponseSchema)` to create a new message.
 */
export const ListFacilityGroupsResponseSchema: GenMessage<ListFacilityGroupsResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 7);

/**
 * @generated from message core.v1.GetFacilityGroupResponse
 */
export type GetFacilityGroupResponse = Message<"core.v1.GetFacilityGroupResponse"> & {
  /**
   * @generated from field: core.v1.FacilityGroup facility_group = 1;
   */
  facilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.GetFacilityGroupResponse.
 * Use `create(GetFacilityGroupResponseSchema)` to create a new message.
 */
export const GetFacilityGroupResponseSchema: GenMessage<GetFacilityGroupResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 8);

/**
 * @generated from message core.v1.CreateFacilityGroupResponse
 */
export type CreateFacilityGroupResponse = Message<"core.v1.CreateFacilityGroupResponse"> & {
  /**
   * @generated from field: core.v1.FacilityGroup facility_group = 1;
   */
  facilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.CreateFacilityGroupResponse.
 * Use `create(CreateFacilityGroupResponseSchema)` to create a new message.
 */
export const CreateFacilityGroupResponseSchema: GenMessage<CreateFacilityGroupResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 9);

/**
 * @generated from message core.v1.UpdateFacilityGroupResponse
 */
export type UpdateFacilityGroupResponse = Message<"core.v1.UpdateFacilityGroupResponse"> & {
  /**
   * @generated from field: core.v1.FacilityGroup facility_group = 1;
   */
  facilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.UpdateFacilityGroupResponse.
 * Use `create(UpdateFacilityGroupResponseSchema)` to create a new message.
 */
export const UpdateFacilityGroupResponseSchema: GenMessage<UpdateFacilityGroupResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 10);

/**
 * Facility group assignment messages
 *
 * @generated from message core.v1.AssignFacilityToGroupRequest
 */
export type AssignFacilityToGroupRequest = Message<"core.v1.AssignFacilityToGroupRequest"> & {
  /**
   * @generated from field: types.ID facility_id = 1;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID facility_group_id = 2;
   */
  facilityGroupId?: ID;
};

/**
 * Describes the message core.v1.AssignFacilityToGroupRequest.
 * Use `create(AssignFacilityToGroupRequestSchema)` to create a new message.
 */
export const AssignFacilityToGroupRequestSchema: GenMessage<AssignFacilityToGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 11);

/**
 * @generated from message core.v1.RemoveFacilityFromGroupRequest
 */
export type RemoveFacilityFromGroupRequest = Message<"core.v1.RemoveFacilityFromGroupRequest"> & {
  /**
   * @generated from field: types.ID facility_id = 1;
   */
  facilityId?: ID;
};

/**
 * Describes the message core.v1.RemoveFacilityFromGroupRequest.
 * Use `create(RemoveFacilityFromGroupRequestSchema)` to create a new message.
 */
export const RemoveFacilityFromGroupRequestSchema: GenMessage<RemoveFacilityFromGroupRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 12);

/**
 * Batch facility group assignment message
 *
 * @generated from message core.v1.UpdateFacilityGroupFacilitiesRequest
 */
export type UpdateFacilityGroupFacilitiesRequest = Message<"core.v1.UpdateFacilityGroupFacilitiesRequest"> & {
  /**
   * @generated from field: types.ID facility_group_id = 1;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: repeated types.ID facility_ids = 2;
   */
  facilityIds: ID[];
};

/**
 * Describes the message core.v1.UpdateFacilityGroupFacilitiesRequest.
 * Use `create(UpdateFacilityGroupFacilitiesRequestSchema)` to create a new message.
 */
export const UpdateFacilityGroupFacilitiesRequestSchema: GenMessage<UpdateFacilityGroupFacilitiesRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 13);

/**
 * @generated from message core.v1.GetFacilityGroupsByCustomAttributeRequest
 */
export type GetFacilityGroupsByCustomAttributeRequest = Message<"core.v1.GetFacilityGroupsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated google.protobuf.Value attribute_values = 2;
   */
  attributeValues: Value[];
};

/**
 * Describes the message core.v1.GetFacilityGroupsByCustomAttributeRequest.
 * Use `create(GetFacilityGroupsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetFacilityGroupsByCustomAttributeRequestSchema: GenMessage<GetFacilityGroupsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 14);

/**
 * @generated from message core.v1.GetFacilityGroupsByCustomAttributeResponse
 */
export type GetFacilityGroupsByCustomAttributeResponse = Message<"core.v1.GetFacilityGroupsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated core.v1.FacilityGroup facility_groups = 1;
   */
  facilityGroups: FacilityGroup[];
};

/**
 * Describes the message core.v1.GetFacilityGroupsByCustomAttributeResponse.
 * Use `create(GetFacilityGroupsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetFacilityGroupsByCustomAttributeResponseSchema: GenMessage<GetFacilityGroupsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup, 15);

/**
 * @generated from enum core.v1.FacilityGroupSortOption
 */
export enum FacilityGroupSortOption {
  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_NAME_ASC = 1;
   */
  NAME_ASC = 1,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_NAME_DESC = 2;
   */
  NAME_DESC = 2,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: FACILITY_GROUP_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum core.v1.FacilityGroupSortOption.
 */
export const FacilityGroupSortOptionSchema: GenEnum<FacilityGroupSortOption> = /*@__PURE__*/
  enumDesc(file_core_v1_facilityGroup, 0);

/**
 * Facility Group query service definition
 *
 * @generated from service core.v1.FacilityGroupQueriesService
 */
export const FacilityGroupQueriesService: GenService<{
  /**
   * @generated from rpc core.v1.FacilityGroupQueriesService.GetFacilityGroup
   */
  getFacilityGroup: {
    methodKind: "unary";
    input: typeof GetFacilityGroupRequestSchema;
    output: typeof GetFacilityGroupResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupQueriesService.ListFacilityGroups
   */
  listFacilityGroups: {
    methodKind: "unary";
    input: typeof ListFacilityGroupsRequestSchema;
    output: typeof ListFacilityGroupsResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupQueriesService.GetFacilityGroupsByCustomAttribute
   */
  getFacilityGroupsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetFacilityGroupsByCustomAttributeRequestSchema;
    output: typeof GetFacilityGroupsByCustomAttributeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_facilityGroup, 0);

/**
 * Facility Group command service definition
 *
 * @generated from service core.v1.FacilityGroupCommandsService
 */
export const FacilityGroupCommandsService: GenService<{
  /**
   * @generated from rpc core.v1.FacilityGroupCommandsService.CreateFacilityGroup
   */
  createFacilityGroup: {
    methodKind: "unary";
    input: typeof CreateFacilityGroupRequestSchema;
    output: typeof CreateFacilityGroupResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupCommandsService.UpdateFacilityGroup
   */
  updateFacilityGroup: {
    methodKind: "unary";
    input: typeof UpdateFacilityGroupRequestSchema;
    output: typeof UpdateFacilityGroupResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupCommandsService.DeleteFacilityGroup
   */
  deleteFacilityGroup: {
    methodKind: "unary";
    input: typeof DeleteFacilityGroupRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Facility group assignment operations
   *
   * @generated from rpc core.v1.FacilityGroupCommandsService.AssignFacilityToGroup
   */
  assignFacilityToGroup: {
    methodKind: "unary";
    input: typeof AssignFacilityToGroupRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupCommandsService.RemoveFacilityFromGroup
   */
  removeFacilityFromGroup: {
    methodKind: "unary";
    input: typeof RemoveFacilityFromGroupRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc core.v1.FacilityGroupCommandsService.UpdateFacilityGroupFacilities
   */
  updateFacilityGroupFacilities: {
    methodKind: "unary";
    input: typeof UpdateFacilityGroupFacilitiesRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_facilityGroup, 1);

